/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ delta: NonNullable<unknown>, date: NonNullable<unknown> }} Body_Assessment_Series_DeltaInputs */

const en_us2_body_assessment_series_delta = /** @type {(inputs: Body_Assessment_Series_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} pp since ${i?.date}`)
};

const pt_br2_body_assessment_series_delta = /** @type {(inputs: Body_Assessment_Series_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} p.p. desde ${i?.date}`)
};

const es_419_body_assessment_series_delta = /** @type {(inputs: Body_Assessment_Series_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} p. p. desde el ${i?.date}`)
};

const pt_pt2_body_assessment_series_delta = /** @type {(inputs: Body_Assessment_Series_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} p.p. desde ${i?.date}`)
};

const fr_fr2_body_assessment_series_delta = /** @type {(inputs: Body_Assessment_Series_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} pts depuis le ${i?.date}`)
};

const de_de2_body_assessment_series_delta = /** @type {(inputs: Body_Assessment_Series_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} Pp. seit ${i?.date}`)
};

const it_it2_body_assessment_series_delta = /** @type {(inputs: Body_Assessment_Series_DeltaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} p.p. dal ${i?.date}`)
};

/**
* | output |
* | --- |
* | "{delta} pp since {date}" |
*
* @param {Body_Assessment_Series_DeltaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_series_delta = /** @type {((inputs: Body_Assessment_Series_DeltaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Series_DeltaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_series_delta(inputs)
	if (locale === "es-419") return es_419_body_assessment_series_delta(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_series_delta(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_series_delta(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_series_delta(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_series_delta(inputs)
	return en_us2_body_assessment_series_delta(inputs)
});
export { body_assessment_series_delta as "body-assessment.series_delta" }